import { render, staticRenderFns } from "./PaymentSection.vue?vue&type=template&id=2888e0e6&scoped=true&"
import script from "./PaymentSection.vue?vue&type=script&lang=js&"
export * from "./PaymentSection.vue?vue&type=script&lang=js&"
import style0 from "./PaymentSection.vue?vue&type=style&index=0&id=2888e0e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2888e0e6",
  null
  
)

export default component.exports